import { Routes } from '@/utils/routes';

/**
 * Build a full URL for an event order form, using the current origin.
 */
export function buildOrderFormUrl(sharedLinkId: string): string {
  const base = window.location.origin;
  return `${base}${Routes.eventOrder(sharedLinkId)}`;
}
